// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class Site {
    static getAttributeTypeMap() {
        return Site.attributeTypeMap;
    }
}
Site.discriminator = undefined;
Site.attributeTypeMap = [
    {
        "name": "description",
        "baseName": "description",
        "type": "string"
    },
    {
        "name": "phoneNumber",
        "baseName": "phoneNumber",
        "type": "string"
    },
    {
        "name": "phoneNumberExtension",
        "baseName": "phoneNumberExtension",
        "type": "string"
    },
    {
        "name": "faxNumber",
        "baseName": "faxNumber",
        "type": "string"
    },
    {
        "name": "faxNumberExtension",
        "baseName": "faxNumberExtension",
        "type": "string"
    },
    {
        "name": "address",
        "baseName": "address",
        "type": "Address"
    }
];
//# sourceMappingURL=site.js.map